export default __webpack_public_path__ + "df37f16f2ac18dfa55ce19edc8adbd7c.png";